import { FC, useCallback, useEffect, useRef } from "react";
import { ReviewChangesProps } from "./ReviewChanges.types";
import { useAddRawProdToSubSpec } from "../../../../services/subrecipe/subrecipe.service";
import { ToastTypes } from "../../../../components/Toast/Toast.types";
import { showToast } from "../../../../components/Toast/Toast";
import { SelectRawProdsContainer, StyledTableWrapper } from "../AddOrChangeRawProd.styles";
import { AxiosError } from "axios";
import { genericErrorShowToastOptions } from "../../../../utils/useGenericErrorMessage/useGenericErrorMessage";
import Input from "../../../../components/Input/Input";
import Button from "../../../../components/Button/Button";
import { TableRowWrapper } from "../../../../common/SideBySideTableLayout/SideBySideTableLayout.styles";
import Table from "../../../../components/Table/Table";
import { EditCellRenderer } from "../../../../components/Table/EditCellRenderer/EditCellRenderer";
import { AgGridReact } from "ag-grid-react";
import { H2 } from "../../../../common/Headings/Headings.styles";
import { Variant } from "../../../../components/Button/Button.types";
// Removed CellEditRequestEvent import
import { InputButtonWrapper, InputWrapper } from "./ReviewChanges.styles";

const ReviewChanges: FC<ReviewChangesProps> = ({
    _specNo,
    selectedOption,
    selectedRawProds,
    setChangeRawProd,
    setAddRawProdsActive,
    setOptionsTableData,
    setSelectedOption,
    setSelectedSubrecipe,
    removeSubrecipeDetails,
    refetch,
    setReviewChanges,
    setSelectedRawProds,
    
}) => {

const {
    mutate: addRawProdRequest,
    isError: addRawProdsError,
    error,
    isLoading: isAddRawProdLoading,
} = useAddRawProdToSubSpec(_specNo, selectedOption?.subSpecNo);
const selectedGridRef = useRef<AgGridReact>(null);


useEffect(() => {
    if (addRawProdsError) {
      if ((error as AxiosError)?.message === 'Request failed with status code 409') {
        refetch();
        showToast({
          ...genericErrorShowToastOptions,
          label: 'Raw product already exists.',
          id: 'optionsRawProdsSaveError',
          toastType: ToastTypes.Error,
        });
      } else {
        showToast(genericErrorShowToastOptions);
      }
    }
  }, [addRawProdsError]);

const handleTextLinkClick = () => {
    setAddRawProdsActive(false);
    setChangeRawProd(false);
    setOptionsTableData([]);
    setSelectedOption(undefined);
    setSelectedSubrecipe(undefined);
    removeSubrecipeDetails();
    };

    const handleAddClick = () => {
        addRawProdRequest(
          {
            rawProdUsages: selectedRawProds.map((rawProd: any) => {
              return {
                moaRawProdNo: rawProd.moaRawProdNo,
                usageAmount: rawProd.usageAmount,
              };
            }),
          },
          {
            onSuccess: () => {
              handleTextLinkClick();
              showToast({
                label: 'Raw product has been added.',
                id: 'optionsRawProdsAddSuccess',
                toastType: ToastTypes.Success,
              });
            },
          }
        );
    };

    const handleCellEdit = useCallback(        (event: any) => {
          let newValue = +event.newValue;
          if (newValue > 9999.9999) newValue = 9999.9999;
          if (newValue < -9999.9999) newValue = -9999.9999;
          if (Number.isNaN(newValue)) newValue = event.oldValue;
          const newSelectedRawProds = selectedRawProds.map((rawProd: any) => {
            if (rawProd.moaRawProdNo === event.data.moaRawProdNo) {
              return {
                ...rawProd,
                usageAmount: newValue,
              };
            } else {
              return rawProd;
            }
          });
          setSelectedRawProds(newSelectedRawProds);
        },
        [selectedRawProds]
      );
    const handleBackClick = () => {
        setReviewChanges(false)
        setSelectedRawProds(selectedRawProds);
    };

return (
    <>
    <SelectRawProdsContainer>
    <H2>Review your changes</H2>
    <InputButtonWrapper>
    <InputWrapper>
        <Input
            id='targetSubspec'
            label='Target Subspec'
            value={`${selectedOption?.subSpecNo?.toString()} - ${selectedOption?.optionDesc}`}
            disabled
        />
        <Input
            id='specNo'
            label='SpecNo'
            value={`${_specNo?.toString()}`}
            disabled
        />
    </InputWrapper>
            
              <Button
                label='Add'
                testId="AddButton"
                onClick={handleAddClick}
                isLoading={isAddRawProdLoading}
              />
    </InputButtonWrapper>
    <TableRowWrapper>
    <StyledTableWrapper>
            <Table
              ref={selectedGridRef}
              showHeader={true}
              headerTitle={'Selected Raw Product'}
              columnDefs={[ 
                { minWidth: 120, flex: 1, field: 'moaRawProdNo', headerName: 'Raw Product' },
                { minWidth: 220, flex: 2, field: 'moaRawProdDesc', headerName: 'Description' },
                {
                  minWidth: 120,
                  flex: 1,
                  field: 'usageAmount',
                  headerName: 'Usage Amount',
                  editable: true,
                  resizable: false,
                  cellRenderer: EditCellRenderer,
                },
              ]}
              rowData={selectedRawProds}
              onCellEditRequest={handleCellEdit}
              readOnlyEdit={true}
              returnedRecords={selectedRawProds?.length}
              height={'100%'}
            />
          </StyledTableWrapper>
    </TableRowWrapper>
    <Button
            label='Back'
            testId="reviewChangesBackButton"
            variant={Variant.Secondary}
            onClick={handleBackClick}
          />
    </SelectRawProdsContainer>
    </>
)
}

export default ReviewChanges;